import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ArticleForm from './ArticleForm';
import { useEditArticleMutation, useGetArticleQuery } from '../../../../redux/apiSlice';

const EditArticle = () => {
  const { id } = useParams();
  const [updateArticle] = useEditArticleMutation();
  const { isError, isLoading, data: formData } = useGetArticleQuery(id);

  const errorMsg = isError ? 'Error while getting article information.Try again later' : '';
  const navigate = useNavigate();
  const handleFormSubmit = async (updateData) => {
    try {
      const res = await updateArticle({
        articleId: id, updates: updateData,
      }).unwrap();
      navigate(`private/editArticle/${res.id}`);
    } catch (error) {
      console.log('error while updating', error);
    }
  };

  return (
    <div>
      {isLoading && <p>Loading...</p>}
      {isError && <p>{errorMsg}</p>}
      <ArticleForm articleData={formData} onSubmit={handleFormSubmit} />
    </div>
  );
};

export default EditArticle;
